var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment } from "react";
import { createUseStyles } from "react-jss";
import { ListCell } from "../..";
import { classNames } from "../../utils/classNames";
import { DATA_COL_INDEX } from "../../utils/gridColumns";
import { canShowTooltip, getItemNodeFormatting, getItemTooltipContent, } from "./utilsV2Table";
import { InlineFeedback } from "./InlineFeedback";
import { GridColumnAlignment } from "../../types/table";
export function V2TableCell(props) {
    var _a, _b;
    var item = props.item, heading = props.heading, colIndex = props.colIndex, cellLink = props.cellLink, drawer = props.drawer, dataId = props.dataId, dataTestId = props.dataTestId, inlineFeedback = props.inlineFeedback;
    var useStyles = useTableCellClasses(colIndex, !!drawer, (_a = heading.alignment) !== null && _a !== void 0 ? _a : GridColumnAlignment.LEFT);
    var classes = useStyles();
    var itemNode = item && getItemNodeFormatting(heading, item);
    var itemTooltipContent = item &&
        canShowTooltip(itemNode, heading) &&
        getItemTooltipContent(heading, item);
    return (React.createElement(ListCell, { ariaColIndex: colIndex, role: "cell", className: classNames(classes.tableCell, classes.cellGrid, (_b = props === null || props === void 0 ? void 0 : props.className) !== null && _b !== void 0 ? _b : ""), link: cellLink, dataId: dataId, dataTestId: dataTestId, dataHook: "table-cell", tooltip: heading.width && ((props === null || props === void 0 ? void 0 : props.tooltipContent) || itemTooltipContent)
            ? {
                width: heading.width,
                content: "".concat((props === null || props === void 0 ? void 0 : props.tooltipContent) || itemTooltipContent),
            }
            : undefined, dataField: "".concat(heading.key, "_").concat(colIndex) }, inlineFeedback ? (React.createElement("span", { className: classes.inlineFeedback }, itemNode !== null && itemNode !== void 0 ? itemNode : props === null || props === void 0 ? void 0 : props.children,
        React.createElement(InlineFeedback, __assign({}, inlineFeedback)))) : (React.createElement(Fragment, null, itemNode !== null && itemNode !== void 0 ? itemNode : props === null || props === void 0 ? void 0 : props.children))));
}
export var TABLE_CELL_STYLING = {
    minHeight: 30,
    padding: [2, 5],
    marginRight: 0,
    "& .list__cell--text": {
        display: "table-cell",
    },
    "& .form-group + .prompt, .form-group + .tooltip--wrapper .prompt, .tooltip--wrapper + .tooltip--wrapper .prompt": {
        paddingTop: 3,
    },
};
export var useTableCellClasses = function (colIndex, hasDrawer, alignment) {
    var cellGrid = {
        gridColumn: colIndex * 1,
        "-ms-grid-column": colIndex * 1,
    };
    if (hasDrawer) {
        cellGrid = __assign(__assign({}, cellGrid), { gridArea: "".concat(DATA_COL_INDEX).concat(colIndex), "-ms-grid-area": "".concat(DATA_COL_INDEX).concat(colIndex) });
    }
    return createUseStyles({
        inlineFeedback: {
            display: "flex",
        },
        tableCell: __assign(__assign({}, TABLE_CELL_STYLING), { textAlign: alignment }),
        cellGrid: cellGrid,
    });
};
